import React, { useState, useEffect, useMemo } from 'react';
import { Tabs } from 'antd';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import ProfileCard from './components/ProfileCard';
import BasicInfo from 'pages/NewUniProfile/components/BasicInfoStep';
import ProfessionalProfile from 'pages/NewUniProfile/components/ProfessionalProfileStep';
import Background from 'pages/NewUniProfile/components/BackgroundStep';
import License from 'pages/NewUniProfile/components/LicenseStep';
import AIChat from 'components/AIChat';
import { EAIChatPageId } from 'types/ai';

const ProfilePage: React.FC = () => {
    const [tabKey, setTabKey] = useState('basic');

    const tabItems = [
        { key: 'basic', label: 'Basic Information', children: <BasicInfo isReview /> },
        { key: 'professional', label: 'Professional Profile', children: <ProfessionalProfile isReview /> },
        { key: 'background', label: 'Background', children: <Background isReview /> },
        { key: 'license', label: 'License', children: <License isReview /> },
    ];


    const handleTabClick = (key: string) => {
        setTabKey(key);
    };

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <div className={s.inner}>Profile</div>
            </div>
            <div className={s.content}>
                <ProfileCard />
                <Tabs activeKey={tabKey} items={tabItems} onTabClick={handleTabClick} />
            </div>
            <div className={commonS.chatWrap}>
                <AIChat
                    pageId={EAIChatPageId.PROVIDER_PROFILE}
                    defaultShow={false}
                    makeFix={false}
                />
            </div>
        </div>
    );
};

export default ProfilePage;
